/**
 * @generated SignedSource<<421d7ef34c15715aa24b43c2d33e7898>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageSectionSidebarText_pageSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSidebarSectionTitle_pageSection"
    }
  ],
  "type": "PageSectionSidebarText",
  "abstractKey": null
};

node.hash = "33304295368d5a108cfd464e4f3b8550";

module.exports = node;
